import React from 'react'
import {Container, Navbar, Nav} from 'react-bootstrap'
import {IconButton, Badge} from '@material-ui/core'
import {ShoppingCart} from '@material-ui/icons'
import {Link, useLocation} from 'react-router-dom'

const NavBar = (cartItems) => {

  const loc = useLocation().pathname;

  return (
    <Navbar bg="light" variant="light" sticky="top">
      <Container>
        <Navbar.Brand className='ml-1' href='/'>SaveYOU</Navbar.Brand>
        <Nav>
        <Link>
        
        </Link>
        <Nav.Link className='mr-5' href='/resources'>Resources</Nav.Link>
        <Nav.Link href='/about'>About</Nav.Link>
        </Nav>
      </Container>
        {loc==='/' ? (<div>
              <IconButton component={Link} to='/cart' aria-label="Show Cart Items">
                <Badge badgeContent={cartItems.cartItems} color="secondary">
                    <ShoppingCart className='mr-1'/>
                </Badge>
              </IconButton>
          </div>):null }
  </Navbar>
  )
}

export default NavBar
